export const TYPES = {
  IApiService: Symbol.for("IApiService"),
  IAddressService: Symbol.for("IAddressService"),
  IUserService: Symbol.for("IUserService"),
  IMemberService: Symbol.for("IMemberService"),
  IMembershipService: Symbol.for("IMembershipService"),
  IContactService: Symbol.for("IContactService"),
  IBookService: Symbol.for("IBookService"),
  IActivityService: Symbol.for("IActivityService"),
  IActivityOccurrenceService: Symbol.for("IActivityOccurrenceService"),
  IOrganizationService: Symbol.for("IOrganizationService"),
  IInvoiceService: Symbol.for("IInvoiceService"),
  IDocumentService: Symbol.for("IDocumentService"),
  IFavoriteDocumentService: Symbol.for("IFavoriteDocumentService"),
  AxiosInstance: Symbol.for("AxiosInstance")
};
